export interface LatestRequestGuard {
	/** Starts a request and returns a check telling whether it is still the latest one. */
	start: () => () => boolean;
	/** Makes every request in flight stale, e.g. when the state they target is reset. */
	invalidate: () => void;
	/** Increases with each started or invalidated request. */
	version: () => number;
}

/**
 * Lets only the latest of concurrent requests apply its response, so a slower
 * earlier response never overwrites a newer one.
 */
export const createLatestRequestGuard = (): LatestRequestGuard => {
	let current = 0;

	return {
		start: () => {
			const requestId = ++current;
			return () => requestId === current;
		},
		invalidate: () => {
			current += 1;
		},
		version: () => current,
	};
};
